export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/dfffdcc654f425d556d7485c2bf841db.svg";